import { PageHeader } from "../../../../Application/layout/PageHeader/PageHeader";

import styles from "./Header.module.scss";

interface Props {
  controls?: React.ReactNode;
  title?: string;
}

export const Header: React.FC<Props> = ({ controls, title }) => {
  return (
    <PageHeader noPadding>
      <div className={styles.header}>
        {title && <h1 className={styles.headerText}>{title}</h1>}
        <div className={styles.controls}>{controls}</div>
      </div>
    </PageHeader>
  );
};
